// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_LiK","cls2":"AuthorHeader-cls2__jM AuthorHeader-cls1_LiK"};